import { BProjectList } from "components/base";
import { observer } from "mobx-react";
import { useCallback, useMemo } from "react";
import { chatStore } from "store/chatStore";
import "./SidebarProjects.scss";

const SidebarProjects = observer(function SidebarProjects() {
  const { projects, selectedProjectId } = chatStore;

  const items = useMemo(
    () => projects.map((p) => ({ id: String(p.id), title: p.name })),
    [projects],
  );

  const handleSelect = useCallback((id: string) => {
    void chatStore.setSelectedProject(Number(id));
  }, []);

  return (
    <div className="sidebar-projects">
      <BProjectList
        items={items}
        activeId={selectedProjectId != null ? String(selectedProjectId) : null}
        title="Dự án"
        emptyDescription="Chưa có dự án"
        onSelect={handleSelect}
      />
    </div>
  );
});

export default SidebarProjects;
